import React from 'react'
import Header from '../../common/Header'
import Footer from '../../common/Footer'

function Bus() {
  return (
    <div>
      <p1></p1>
      <div></div>
      Bus</div>
  )
}

export default Bus